"use client";

import { strictLocalize } from "@faire/web/common/localization";
import * as React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Close from foundation/Close
 * @trackcomponent
 */
export const Close = createSVGIcon(
  <path stroke="currentColor" d="M2.667 2l11.07 11.552M2 13.07L13.552 2" />,
  "Close",
  {
    viewBox: "0 0 15 15",
    strokeLinecap: "square",
    strokeWidth: 2,
  }
);

/**
 * @deprecated use Close from foundation/Close
 * @trackcomponent
 */
export const CloseCircle = createSVGIcon(
  <>
    <g
      id="320/Navigation/Active"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-236.000000, -21.000000)"
    >
      <g
        id="Element-/-Global-Search-/-Default"
        transform="translate(10.000000, 9.000000)"
        fill="currentColor"
      >
        <g id="Icon-/-Clear-/-Dark">
          <g transform="translate(226.000000, 12.000000)">
            <path
              d="M14,7 C14,10.866 10.866,14 7,14 C3.13403,14 0,10.866 0,7 C0,3.13403 3.13403,0 7,0 C10.866,0 14,3.13403 14,7 L14,7 Z M5.18185689,4.20282624 C4.91148714,3.93239125 4.47315399,3.93239125 4.20278424,4.20282624 C3.93240525,4.47303046 3.93240525,4.91158616 4.20278424,5.18179038 L6.02093542,7.00001038 L4.20278424,8.81823038 C3.93240525,9.0884346 3.93240525,9.52699031 4.20278424,9.79722222 C4.47315399,10.0675926 4.91148714,10.0675926 5.18185689,9.79722222 L7.00001731,7.97898376 L8.81817773,9.79722222 C9.08854748,10.0675926 9.52688063,10.0675926 9.79722269,9.79722222 C10.0675924,9.52699031 10.0675924,9.0884346 9.79722269,8.81823038 L7.97909919,7.00001038 L9.79722269,5.18179038 C10.0675924,4.91158616 10.0675924,4.47303046 9.79722269,4.20282624 C9.52688063,3.93239125 9.08854748,3.93239125 8.81817773,4.20282624 L7.00001731,6.02103701 L5.18185689,4.20282624 L5.18185689,4.20282624 Z"
              id="Clear"
            />
          </g>
        </g>
      </g>
    </g>
  </>,
  "Close",
  {
    viewBox: "0 0 14 14",
    strokeLinecap: "square",
    titleAccess: strictLocalize({
      defaultMessage: "Close",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
  }
);
